/**
 * ShareLinkButton - Button to trigger share link modal
 */

import React, { useState } from 'react';
import { Button, IconButton, MenuItem, Tooltip, useToast } from '@chakra-ui/react';
import { Share } from 'lucide-react';
import { ShareLinkModal } from './ShareLinkModal';


interface ShareLinkButtonProps {
  variant?: 'button' | 'icon' | 'menuItem';
  size?: 'sm' | 'md' | 'lg';
  chartData?: any; // Chart API response data
  isDisabled?: boolean; // If true, button is disabled
}

export function ShareLinkButton({
  variant = 'button',
  size = 'md',
  chartData,
  isDisabled = false
}: ShareLinkButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toast = useToast();

  const handleClick = () => {
    setIsModalOpen(true);
  };

  if (variant === 'icon') {
    return (
      <>
        <Tooltip label={isDisabled ? 'Quota full' : 'Create share link'} placement="bottom">
          <IconButton
            aria-label="Create share link"
            icon={<Share size={18} />}
            onClick={handleClick}
            variant="ghost"
            size={size}
            isDisabled={isDisabled}
          />
        </Tooltip>
        <ShareLinkModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} chartData={chartData} />
      </>
    );
  }

  if (variant === 'menuItem') {
    return (
      <>
        <MenuItem icon={<Share size={16} />} onClick={handleClick} isDisabled={isDisabled}>
          Create Short Link
        </MenuItem>
        <ShareLinkModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} chartData={chartData} />
      </>
    );
  }

  return (
    <>
      <Button
        leftIcon={<Share size={16} />}
        onClick={handleClick}
        size={size}
        colorScheme="blue"
        variant="outline"
        isDisabled={isDisabled}
      >
        Create Short Link
      </Button>
      <ShareLinkModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} chartData={chartData} />
    </>
  );
}
